<ion-header>
    <ion-row class="years">
        <button *ngFor="let year of availableYears; let i = index;" (click)="selectYear(year)"> {{ year }}
        </button>
    </ion-row>
</ion-header>
<ion-content class="ion-no-padding calibration">
    <ng-container *ngIf="userOverviews">
        <ion-grid class="header">
            <ion-row class="ion-padding">
                <ion-col class="user" size="3">
                    <img style="height: 80px; width: 80px;" [src]="getImageUrl(participant?.user?.imageUrl)"
                        default="" />
                    <p>
                        {{ participant?.user?.name }}
                        <br>
                        <small>{{ participant?.user?.rank }}</small>
                    </p>
                </ion-col>
                <ion-col size="6">
                    <ion-grid>
                        <ion-row>
                            <ion-col size="5">
                                <span>{{ 'generic.group' | translate }}:</span><br />
                                {{ participant?.user?.group || '--' }}
                            </ion-col>
                            <ion-col size="3.5">
                                <span>{{ 'cycleParticipants.location' | translate }}:</span><br />
                                {{ participant?.user?.location || '--' }}
                            </ion-col>
                            <ion-col size="3.5">
                                <span>{{ 'dashboard.lineManager' | translate }}</span>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="5">
                                <span>{{ 'cycleParticipants.businessUnit' | translate }}:</span><br />
                                {{ participant?.user?.unit || '--' }}
                            </ion-col>
                            <ion-col size="3.5">
                                <span>{{ 'generic.serviceDate' | translate }}:</span>
                                <br />
                                {{ getLocalDate(participant?.user?.serviceDate?.toString()) | date : 'dd/MM/yyyy' }}
                            </ion-col>
                            <ion-col size="3.5">
                                <img class="manager" [src]="getImageUrl(participant?.user?.lineManagerImage)" default=""
                                    alt="" />
                                {{ participant?.user?.lineManager }}
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="5">
                                <span>
                                    {{ 'cycleParticipants.segment' | translate }}:
                                </span>
                                <br />
                                {{ participant?.user?.segment || '--' }}
                            </ion-col>
                            <ion-col size="3.5">
                                <ng-container *ngIf="!hideHireDate">
                                    <span>{{ 'generic.hireDate' | translate }}:</span>
                                    <br />
                                    {{ getLocalDate(participant?.user?.hireDate?.toString()) | date : 'dd/MM/yyyy' }}
                                </ng-container>
                            </ion-col>
                            <ion-col size="3.5">
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-col>
                <ion-col class="table" size="3">
                    <ion-card>
                        <ion-grid>
                            <ion-row>
                                <ion-col size="3.4"></ion-col>
                                <ion-col [size]="(8.6/userOverviews.length)" *ngFor="let year of availableYears">
                                    {{ year }}
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col size="3.4">
                                    {{ 'generic.evaluation' | translate }}
                                </ion-col>
                                <ion-col [size]="(8.6/userOverviews.length)" *ngFor="let year of availableYears">
                                    {{ getPreviousYearStat(year, 'evaluation') }}
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col size="3.4">
                                    {{ 'cycleParticipants.rank' | translate }}
                                </ion-col>
                                <ion-col [size]="(8.6/userOverviews.length)" *ngFor="let year of availableYears">
                                    {{ getPreviousYearStat(year, 'rank') }}
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>

        <ion-grid class="body">
            <ion-row>
                <ion-col size="7">
                    <ion-card mode="ios" *ngIf="!hideOverallEvaluationCard">
                        <ion-card-header color="">
                            <ion-card-title color="primary">
                                {{ 'calibration.overallEvaluation' | translate | uppercase }}
                            </ion-card-title>
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <app-calibration-overall-evaluation [participant]="participant"
                                [meetingInProgress]="meetingInProgress" [showTooltips]="true"
                                (goToManagerEvaluation)="goToManagerEvaluation()">
                            </app-calibration-overall-evaluation>
                        </ion-card-content>
                    </ion-card>
                    <ion-card mode="ios" *ngFor="let questionGroup of participant?.threeSixtyEvaluationCalibrationData">
                        <ion-card-header color="">
                            <ion-card-title color="primary">
                                {{ getText(questionGroup.globalizationConfig, 'title') }}
                            </ion-card-title>
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <app-calibration-qualitative-evaluation [questions]="questionGroup.questions"
                                [possibleValues]="participant?.ratings?.ratingsPossibleValues"></app-calibration-qualitative-evaluation>
                        </ion-card-content>
                    </ion-card>
                    <ion-card mode="ios" *ngIf="lastQuestionGroupCalibration" style="margin-top: 10px;">
                        <ion-card-header>
                            <ion-card-title color="primary">
                                {{ getText(lastQuestionGroupCalibration?.globalizationConfig, 'title') }}
                            </ion-card-title>
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <app-calibration-qualitative-evaluation
                                [questions]="lastQuestionGroupCalibration?.questions"
                                [possibleValues]="participant?.ratings?.ratingsPossibleValues">
                            </app-calibration-qualitative-evaluation>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
                <ion-col size="5">
                    <ion-card mode="ios" *ngFor="let questionGroup of questionGroupsCalibrationData">
                        <ion-card-header color="">
                            <ion-card-title color="primary">
                                {{ getText(questionGroup.globalizationConfig, 'title') }}
                            </ion-card-title>
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <app-calibration-qualitative-evaluation [questions]="questionGroup.questions"
                                [possibleValues]="participant?.ratings?.ratingsPossibleValues"></app-calibration-qualitative-evaluation>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>
    <ng-template #loading></ng-template>
</ion-content>

<ion-footer mode="ios">
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col size="3">
                <ion-button *ngIf="positions.hasPrevious" fill="clear" mode="ios" color="primary"
                    [hidden]="managerEvaluationView" (click)="dismiss('previous')">
                    <ion-icon class="bp-arrow-left"></ion-icon>
                    <span style="margin-bottom: 3px;">{{ 'generic.previous' | translate }}</span>
                </ion-button>
            </ion-col>
            <ion-col size="6">
                <ion-button *ngIf="aiReviewEnabled && (hasAiReviewRole || hasAiReviewAttribute)" size="small"
                    fill="clear" mode="ios" color="secondary" (click)="openAiGeneralSummaryModal()"
                    [disabled]="!userOverviews">
                    <div class="icon-custom-star-shining"></div>
                    &nbsp; {{ 'aiSummary.detailed.buttonTitle' | translate }}
                </ion-button>
                <ion-button *ngIf="canExportFullReport" fill="clear" color="secondary" mode="ios"
                    (click)="viewFullReport()">
                    <img src="./assets/imgs/Relatorio_Completo_icon.svg" />&nbsp; {{
                    'calibration.fullReport' | translate
                    }}
                </ion-button>
                <ion-button *ngIf="canExportReport" fill="clear" color="secondary" mode="ios" (click)="exportReport()">
                    <img src="./assets/imgs/exportar_resumo_icon.svg" />&nbsp; {{
                    'generic.export' | translate
                    }}
                </ion-button>
                <ion-button *ngIf="canViewComments" fill="clear" color="secondary" mode="ios"
                    (click)="viewUserComments(userInfo)">
                    <img class="comment"
                        [src]="(userInfo && userInfo.notes )? './assets/imgs/comments_full.png' : './assets/imgs/no_comments.png'" />&nbsp;
                    {{ 'generic.comment' | translate }}
                </ion-button>
                <ion-button fill="clear" mode="ios" color="danger" (click)="dismiss()">
                    <ion-icon class="bp-close"></ion-icon>
                    &nbsp; {{ 'generic.close' | translate }}
                </ion-button>
            </ion-col>
            <ion-col size="3">
                <ion-button *ngIf="positions.hasNext" fill="clear" mode="ios" color="primary"
                    [hidden]="managerEvaluationView" (click)="dismiss('next')">
                    <span style="margin-bottom: 3px;">{{ 'generic.next' | translate }}</span>
                    <ion-icon class="bp-arrow-right"></ion-icon>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>